export default "__VITE_ASSET__CJ4GpWiz__"